import React from "react";
import { useTranslation } from "react-i18next";
import { AnimatedLogo } from "./AnimatedLogo";
import "./LoadingScreen.scss";

interface LoadingScreenProps {
  message?: string;
  inline?: boolean;
}

const LoadingScreen: React.FC<LoadingScreenProps> = ({ message, inline }) => {
  const { t } = useTranslation();

  return (
    <div className={inline ? "loading-screen loading-screen--inline" : "loading-screen"}>
      <div className="loading-content">
        <AnimatedLogo />
        <p className="loading-message">
          {message || t("common.labels.loading")}
        </p>
      </div>
    </div>
  );
};

export default LoadingScreen;
